import Point from "./classes/Point";
import { Vector } from "./classes/Vector";

const TIER_COLORS = [0xeb5f2d, 0x5a46d7, 0x39b8d5, 0x50eb82];

// TRAIL of points
const TRAIL_POINTS: { point: Point; vector: Vector; draw: boolean }[] = Array(
  100
)
  .fill("")
  .map(() => ({
    point: new Point(0, 0),
    vector: new Vector(0, 0),
    draw: false,
  }));

export function drawTrail(
  graphics,
  { dist, rad, velocity, count, center, isPointerDown }
) {
  const perp = rad + Math.PI * 0.5;
  const mult = isPointerDown ? 3 : 1;
  const lineWidth = Math.max(dist * 0.1, 10) - Math.cos(count) * 3;

  // Move last to front
  const nextMove = TRAIL_POINTS.pop();
  nextMove.draw = true;
  nextMove.vector.update(rad, velocity);
  nextMove.point
    .moveTo(center.x, center.y)
    .move(nextMove.vector.x, nextMove.vector.y);
  TRAIL_POINTS.unshift(nextMove);

  TIER_COLORS.forEach((color, i) => {
    // @ts-ignore
    graphics.lineStyle({
      width: lineWidth * (TIER_COLORS.length - i),
      color: color,
      miterLimit: 1000,
      alignment: 0.5,
      join: "round",
      cap: "round",
    });
    TRAIL_POINTS.forEach((current, j) => {
      // only update points first color loop
      if (i === 0) {
        current.point.move(current.vector.x, current.vector.y);
        const decrease = 1 - j / TRAIL_POINTS.length;
        const sine =
          Math.sin(0.3 * j * mult + count) * dist * 0.02 * decrease * mult;
        current.point.moveAtAngle(perp, sine);
      }

      // move to right place to start drawing
      if (j === 0) {
        graphics.moveTo(current.point.x, current.point.y);
        // return;
      }

      if (!current.draw) return;
      // draw line
      graphics.lineTo(current.point.x, current.point.y);
    });
  });
}
